import { Button, Dropdown, Input, Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { GoPlusCircle } from "react-icons/go";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IoDocumentTextOutline } from "react-icons/io5";
import { IoIosSearch, IoMdPerson } from "react-icons/io";
import { useMessage } from "../MessageProvider/MessageProvider";
import axiosInstance from "../axiosInstance/AxiosInstance";
import { BsPersonDash, BsThreeDotsVertical } from "react-icons/bs";
import CustomersList from "./CustomersList";
import CustomersAdd from "../../Pages/Customers/CustomersAdd";
import { HiOutlineDocumentText } from "react-icons/hi";
import { TbMoneybag, TbSmartHome } from "react-icons/tb";
import Karzinka from "./Karzinka/Karzinka";

export default function CustomersHeader() {
  let navigate = useNavigate();
  const messageApi = useMessage();
  const [loading, setLoading] = React.useState(false);
  const [options, setOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [openKarzinka, setOpenKarzinka] = useState(false);
  const { id } = useParams();
  let searchRef = useRef(null);

  const handleSearch = async (value) => {
    try {
      setLoading(true);

      let { data } = await axiosInstance.get(
        "/api/customers/search?search=" + value
      );
      console.log(data);
      setOptions(data?.data);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setIsModalOpen(false);
  }, [id]);

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.focus();
    }
  }, [isModalOpen]);

  const items = [
    {
      key: "1",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/customers"
        >
          <IoMdPerson /> Xaridorlar
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          // to="/checkUser"
          onClick={() => {
            setOpen(true);
          }}
        >
          <GoPlusCircle className="font-[30px]" /> Xaridor
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kassa"
        >
          <TbMoneybag className="font-[30px]" /> Kassa
        </Link>
      ),
    },
    {
      key: "4",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/tickets"
        >
          <IoDocumentTextOutline className="font-[30px]" />
          Tiketlar
        </Link>
      ),
    },
    {
      key: "5",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/yukxati"
        >
          <HiOutlineDocumentText className="font-[30px]" /> Yuk xatlari
        </Link>
      ),
    },
    {
      key: "6",
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          onClick={() => {
            setOpenKarzinka(true);
          }}
        >
          <BsPersonDash className="font-[30px]" /> Karzinka
        </div>
      ),
    },
    {
      key: "7",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/"
        >
          <TbSmartHome className="font-[30px]" /> Bosh sahifa
        </Link>
      ),
    },
  ];

  return (
    <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row pb-[5px] items-center justify-between">
      <h2 className="bold text-[20px] m-0 p-0">Xaridorlar</h2>
      <Modal
        style={{ top: "10px", width: "900px" }}
        title="Qidirish"
        open={isModalOpen}
        width={800}
        //   loading={loadVagon}
        onOk={() => {
          setIsModalOpen(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setIsModalOpen(false);
        }}
        footer={[]}
      >
        <div className="">
          <div className=" pb-1">
            <Input
              loading={loading}
              size="large"
              placeholder="Qidirish..."
              enterButton
              inputRef={searchRef}
              onChange={(e) => {
                handleSearch(e.target.value);
              }}
            />
          </div>
          <CustomersList data={options} />
        </div>
      </Modal>
      
      <CustomersAdd setOpen={setOpen} open={open} />
      {/* karzinka */}
      <Karzinka open={openKarzinka} setOpen={setOpenKarzinka} />
      <div className="flex gap-1">
        <Button
          onClick={() => {
            setIsModalOpen(true);
            if (searchRef.current) {
              console.log("focus");
              searchRef.current.focus();
            }
          }}
          variant="solid"
          icon={<IoIosSearch className="font-[30px]" />}
        ></Button>
        {/* <BsThreeDotsVertical /> */}
        <Dropdown
          menu={{
            items,
          }}
          placement="topRight"
          arrow
        >
          <Button icon={<BsThreeDotsVertical />}></Button>
        </Dropdown>
      </div>
    </div>
  );
}
